var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('label', {
    staticClass: "checkbox-container radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.updateValue
    }
  }), _c('span', {
    staticClass: "container-align",
    class: _vm.disabled ? 'disabled' : ''
  }, [_c('span', {
    staticClass: "checkmark",
    class: _vm.isChecked ? 'checked' : ''
  }, [_c('span', {
    staticClass: "check"
  })]), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.label))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };